<template>
    <div>
      <div class="header_index_nav">
        <header>
          <div class="index_nav_white top">
            <div class="nav_box">
              <div class="nav_flex">
                <div class="nav_logo_b" @click="toMain"></div>
                <div class="nav_li">
                  <div class="nav_li_text" @click="headerClick('aboutus')">关于我们</div>
                  <div class="nav_li_text" @click="headerClick('society')">社会责任</div>
                  <div class="nav_li_text" @click="headerClick('news')">新闻动态</div>
                  <div class="nav_li_text" @click="headerClick('InvestorRelations')">投资者关系</div>
                  <div class="nav_li_text" @click="headerClick('joinUs')">加入我们</div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
      <main class="index_main_content" ref="parentDiv">
        <div class="privacy_box">
            <div class="privacy_line">
                <div class="privacy_title">金山软件集团隐私保护政策</div>
                <div class="privacy_time">更新日期：2024年3月15日</div>
            </div>
            <div class="privacy_content">
                <div>
                    金山软件集团（指Kingsoft Corporation Limited及其并表子公司，以下简称“集团”或“我们”）致力于保护您的隐私，
                    并在我们的网站及使用我们的产品和/或服务时为您提供积极的体验。我们深知个人信息对您的重要性，并将按照法律法规要求
                    和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
                </div><br>
                <div>
                    本隐私政策适用于金山软件集团提供的产品或服务，本政策旨在说明我们提供的产品和/或服务时如何收集、使用、存储、删除
                    您的个人信息。本政策中与您的权益（可能）密切相关的重要条款，已采用加粗字体来特别提醒您，请您重点查阅。
                    <b>【特别提示】针对某些特定的产品和/或服务，我们将制定单独的隐私政策以向您说明这些产品和/或服务的特殊政策。
                    <span class="ubderline">如相关特定的隐私政策与本隐私政策有不一致之处，适用该特定隐私政策。</span>本隐私政策亦不适用于其他第三方向您提供的产品或服务，
                    第三方向您提供的产品或服务适用该第三方向您说明的隐私政策。</b>
                </div><br>
                <div>如对本隐私政策内容有任何疑问，您可通过本隐私政策“如何联系我们”中披露的联系方式与我们联系。</div><br>
                <div><b>本政策将帮助您了解以下内容：</b></div>
                <div>一、我们如何收集和使用您的个人信息</div>
                <div>二、我们如何使用Cookie和同类技术</div>
                <div>三、我们如何共享、转让、公开披露您的个人信息</div>
                <div>四、我们如何保存和保护您的个人信息</div>
                <div>五、未成年人的个人信息保护</div>
                <div>六、通知和修订</div>
                <div>七、如何联系我们</div><br>
                <h3>一、我们如何收集和使用您的信息</h3><br>
                <div>您理解并同意：</div><br>
                <div>
                    1.为满足不同用户的需求，我们致力于打造多样的产品和/或服务，不同用户选择使用的具体产品和/或服务范围可能存在差异。相应地，
我们收集使用的个人信息类型、范围等会有所区别，请以具体的产品/和/或服务功能为准。<b>关于具体产品和/或服务如何收集、使用您的个人信息，
请以我们针对该具体产品和/或服务制定的特定隐私政策为准。</b>
                </div><br>
                <div>
                    2.在处理您的个人信息方面，我们致力于维持您对我们的信任，并恪守权责一致原则、目的明确原则、选择同意原则、
                    最小必要原则、确保安全原则、主体参与原则、公开透明原则，以保护您的个人信息。
                </div><br>
                <div><h4>(一)账号注册及账户管理</h4></div><br>
                <div>
                    如您使用特定产品和/或服务，将注册成为相应产品和/或服务用户时，您需按照相关产品的要求提供您的个人信息以完成注册程序，
                    需提供的具体个人信息内容以相关产品隐私政策要求为准。一般而言，个人信息内容需要至少提供<b><span class="ubderline">手机号码</span></b>以创建相关产品的账号，
                    并完善相关的网络身份识别信息（如头像、昵称及登录密码等）。如您选择授权使用第三方账号注册、登录时，我们将根据您的授权
                    获取该等账号下的相关信息（例如：用户名、昵称、open ID等，具体以您的授权内容为准），用于帮助您完成登录和实现其他功能。
                    关于第三方平台向我们提供的信息，请您在登录时仔细阅读相关登录界面的专门提示。
                </div><br>
                <div>请您知悉并理解，如相关产品要求收集手机号码的，其目的是满足相关法律法规的网络实名制要求，若您不提供这类信息，
                    将可能无法正常使用需要完成实名认证后方可使用的服务。如您仅需浏览、搜索我们网站和产品页面展示的信息，
                    您不需要注册账号和提供上述信息。</div><br>
                <div><h4>(二)产品服务</h4></div><br>
                <div>
                  为了向您提供相关产品服务，当您使用我们的产品时，我们可能会自动收集您对我们服务的详细使用情况，作为有关网络日志保存，具体收集内容、
                  范围、收集方式以相应产品的隐私政策规定为准。一般而言可能会包括，您的IP地址、浏览器的类型、使用的语言、访问日期和时间、
                  您访问的网页记录等操作日志信息。
                </div><br>
                <div><b>请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。</b>如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将有可能被视为个人信息，则在结合使用期间，我们会一同按照本政策对其进行处理与保护,除取得您授权或法律法规另有规定外，我们在产品运营期结束后会将该类个人信息做匿名化、去标识化处理。</div><br>
                <div><h4>(三)信息公开发布功能</h4></div><br>
                <div>
                  如相关产品中包括信息发布功能，您在使用前述功能时可能会发布<b>图文、链接、个人定位或发表评价意见的。</b>请注意，您公开发布的信息
                  中可能会涉及<b>您或他人的个人信息甚至个人敏感信息（如个人地理位置）</b>，如您在评价时选择上传包含个人信息的图文。请您更加谨慎地
                  考虑，<b>是否在使用我们的服务时共享甚至公开分享相关信息，若您公开发布的信息中涉及他人个人信息的，您需在发布前征得他人的同意。</b>
                </div><br>
                <div><h4>(四)保证安全</h4></div><br>
                <div>
                  为提高您使用我们提供的产品和/或服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、
                  计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或公司相关服务协议的情况，我们可能会收集、使用或整合您的<b>账号信息、
                  设备信息、应用信息、日志信息取得您授权或依据法律共享的信息，来综合判断您账号及交易风险、进行身份验证、检测及防范安全事件，
                  并依法采取必要的记录、审计、分析、处置措施。</b>
                </div><br>
                <div><h4>(五)其他用途</h4></div><br>
                <div><h4>1.售后服务支持</h4></div>
                <div>
                  如您在使用产品和/或服务过程需要售后服务支持，我们会根据您的账号信息核对您的身份及购买的相关产品或服务（如有），我们还将根据您使用相应产品及服务的软件信息、设备信息、网络位置信息、日志信息以及您发送的邮件内容、截图、文档、公众号留言或与我们客服人员的电话对话内容等帮您查找原因和解决问题。您需提供的信息将以具体产品和/或服务隐私政策说明为准。
                </div><br>
                <div><h4>2.消息推送</h4></div>
                <div>
                  如您使用的产品和/服务有消息推送功能的，在您使用前述功能过程中，我们会使用您的设备信息、账号信息、手机号码或邮箱，通过包括但不限于弹窗、通知、站内信、电子邮件、短信等方式向您推送有关服务的不同类型消息，以帮助您及时获悉消息并相应决策。我们使用的信息内容将以具体产品和/或服务隐私政策规定为准。您不希望收到这些通知，可以按照相关产品的具体提示，通过相应设置选择取消订阅，或通过该产品的其他取消功能要求我们停止基于上述用途处理您的个人信息。
                </div><br>
                <div>
                  针对不同的产品和/或服务，我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您无法取消这些与服务有关、性质不属于广告的公告。
                </div><br>
                <div>
                  如您使用的产品和/服务有推荐服务功能的，在您使用前述功能过程中，我们会使用您的软件信息、账号信息、设备信息、使用产品和/或服务的行为数据，
                  向您展现或推送相关服务。我们使用的信息内容将以具体产品和/或服务隐私政策规定为准。您亦可选择关闭推荐功能，不影响您正常使用我们的其他服务。
                </div><br>
                <div><h4>3.第三方渠道购买产品和/或服务</h4></div>
                <div>
                  如您从我们的经销商、代理商渠道购买产品和/或服务的，我们将从该等第三方渠道获取您的订单信息，一般包括您的姓名/昵称、使用账号信息所购买的产品和/或服务的具体内容信息以便为您提供相应产品和/或服务，具体以您授权该第三方渠道提供给我们的信息为准，关于第三方渠道向我们提供的信息，请您在购买时仔细阅读相关界面的专门提示或查看第三方渠道的隐私政策。
                </div><br>
                <div><h4>4.参与活动</h4></div>
                <div>
                  当您参与了我们不定期推出的包括但不限于抽奖、赠送、福利领取、促销、使用积分兑换商品的活动，在需要向您发放相关奖品、礼品、商品时，将使用您指定的收件人的收货信息（收货人姓名、收货电话、收货地址）。
                </div><br>
                
                <div><h4>(六)征得授权同意的除外</h4></div><br>
                <div>您充分知悉，在以下情形中，我们收集、使用个人信息无须征得您的授权同意：</div>
                <div>（1）为订立、履行您作为一方当事人的合同所必需；</div>
                <div>（2）为履行法定职责或者法定义务所必需；</div>
                <div>（3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</div>
                <div>（4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</div>
                <div>（5）在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</div>
                <div>（6）法律、行政法规规定的其他情形。</div><br>

                <div><h4>(七)停止运营</h4></div><br>
                <div>
                  如我们停止运营相关产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知<b>至少提前30天以公告的形式通知您</b>，
                  并依照所适用的法律对所持有的您的个人信息进行<b>删除或匿名化</b>处理。
                </div><br>
                <h3>二、我们如何使用Cookie和同类技术</h3><br>
                <div>
                  为确保产品和/或服务的正常运转，我们会使用相关技术向您的设备存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。我们可能会设置认证与保障安全性的Cookie，以确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。使用Cookie还可以帮助您省去重复填写个人信息、输入搜索内容的步骤和流程。
                </div><br>
                <div>
                  我们不会将Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。<b>如果您的浏览器或浏览器附加服务允许，
                  您可以修改对Cookie的接受程度或者拒绝我们的Cookie</b>，如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
                </div><br>
                <h3>三、我们如何共享、转让、公开披露您的信息</h3><br>
                <div><h4>(一)共享</h4></div><br>
                <div>
                  我们在遵守“合法正当、最小必要、目的明确原则”的前提下共享您的个人信息，只有在获得您的明确同意后，我们会与其他方共享您的个人信息。同时，我们将对个人信息的共享活动事先进行个人信息保护影响评估。您的信息共享情况请以相关产品和/或服务的隐私政策约定为准。
                </div><br>
                <div><h4>(二)转让</h4></div><br>
                <div>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</div>
                <div>1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</div>
                <div>
                  2.当我们因公司合并、分立、解散、被宣告破产的原因需求转让您的个人信息的，我们会向您告知接收方的名称或者姓名以及联系方式，并依照法律相关规定由该新公司重新征得您的同意。
                </div><br>
                <div><h4>(三)公开披露</h4></div><br>
                <div>我们仅会在以下情况下，公开披露您的个人信息：</div>
                <div>1.获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息； </div>
                <div>
                  2.基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
                </div><br>
                <div><h4>(四)共享、转让、公开披露个人信息时事先征得授权同意的例外</h4></div><br>
                <div>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</div>
                <div>（1）为订立、履行您作为一方当事人的合同所必需；</div>
                <div>（2）为履行法定职责或者法定义务所必需；</div>
                <div>（3）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</div>
                <div>（4）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</div>
                <div>（5）在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</div>
                <div>（6）法律、行政法规规定的其他情形。</div><br>
                <div>
                  请您注意，根据法律规定，<b>共享、转让经匿名化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，
                  不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</b>
                </div><br>
                <h3>四、我们如何保存和保护您的信息</h3><br>
                <div><h4>(一)我们如何保护您的信息</h4></div><br>
                <div>
                  1.我们非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，防止个人信息遭到未经授权的泄露、篡改、丢失。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
                </div><br>
                <div>
                  2.请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。为更有效的保障您的信息安全，我们也希望您能够加强自我保护意识，请您妥善保管您的账号及密码信息，避免您的个人信息泄露。
                </div><br>
                <div>
                  3.当我们获悉发生了个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能造成的危害、我们采取的处置措施、您可采取的减轻危害的措施。我们会及时将事件相关情况以推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
                </div><br>
                <div><h4>(二)我们如何存储您的信息</h4></div><br>
                <div>
                  1.我们存储您的个人信息，以使您能够继续使用我们的服务，在法律规定的保留期结束后，我们会删除或匿名您的数据。但国家法律法规、规章、规范性文件或政府的政策、命令等另有要求或为履行我们的合规义务而保留您的个人信息的除外。例如：《电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；《网络安全法》要求采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月。
                </div><br>
                <div>
                  2.根据您与相关产品和/或服务的交互范围，您的个人信息将存储在依据用户协议确定的国家或地区，在中国境内运营过程中收集和产生的您的个人信息将存储于中国境内。
                </div><br>
                <h3>五、未成年人的个人信息保护</h3><br>
                <div>
                  我们非常注重未成年人的保护。我们希望未成年人在接受监护人指导、监督并经其同意的前提下使用本服务。
                </div><br>
                <div>
                  如您为未成年人的，<b>建议您在您的父母或其他监护人的指导下使用我们的产品或服务，如您未满14周岁，应事先取得您的家长或监护人的同意，
                  关于未满14周岁的未成年人的个人信息保护措施请参见具体产品的儿童隐私保护政策。</b>
                </div><br>
                <div>
                  如您是未满14周岁的未成年人，但未能获得您监护人的同意使用了我们的产品或服务并向我们提供信息，请您或您的监护人立即停止使用本产品并及时与我们取得联系。若您已经获得监护人的同意，请您与您的监护人共同阅读本政策中对于用户数据收集的相关规定，并确保我们对您个人数据的收集已经获得了您的监护人的同意。若我们一旦发现相关数据的收集未取得您的监护人的同意，我们将临时暂停本产品对您的相关服务，并会设法尽快删除相关数据。
                </div><br>
                <h3>六、通知和修订</h3><br>
                <div>
                  为给您提供更好的服务以及随着我们业务的发展，本政策之规定可能会不定期地修改，本政策更新后，我们会在您登录及版本更新时以推送通知等形式向您展示变更后的本政策，以便您及时了解本政策的最新版本。如因我们所提供的产品和/或服务内容发生变化，所对应的个人信息处理的目的、方式、种类相应的也发生变更的，我们会按照相关法律规定的要求，就变更后的相关内容重新取得您的同意。
                </div><br>
                <h3>七、如何联系我们</h3><br>
                <div>如果您对本隐私政策有任何意见或疑问，或对我们处理您的个人信息有任何疑问，您可以通过本政策公布的联系方式与我们联系。我们会在十五个工作日内完成核查和处理。</div><br>
                <div>公司邮箱：<a href="mailto:legal@kingsoft.com">legal@kingsoft.com</a></div>
                <div>联系电话：010-62927777</div>

            </div>
        </div>
  
      </main>
      <footer-build @gotoBody="gotoBody"></footer-build>
      
      
    </div>
  </template>
  <script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import UtilEvent from '../utils/UtilEvent.js'
  export default {
    name: 'privacyPolicy',
    props: [''],
    components:{UtilEvent},
    data(){
      return{
        detailData:{},
      }
    },
    methods:{
      ...mapActions("global", ["ActionSetCurrentTap"]),
      gotoBody(){
        this.$refs.parentDiv.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      },
      toMain(){
        // this.ActionSetCurrentTap('');
        this.$router.push({name:'main'})
      },
      headerClick(pageName){
        this.ActionSetCurrentTap(pageName);
        this.$router.push(pageName);
      },
      
    },
    mounted(){
      
    }
  }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="less"> 

  </style>
  